export type AffiliationField = {
  key: string;
  kind: string;
  label: string;
  required: boolean;
  options: string[] | null;
};

export type GetAffiliationFieldsResult = {
  data: {
    getAffiliationFields: AffiliationField[] | null;
  };
};

export const getAffiliationFieldsMutation = `
  mutation GetAffiliationFields($affiliationType: AffiliationType!) {
    getAffiliationFields(affiliationType: $affiliationType) {
      key
      kind
      label
      required
      options
    }
  }
`;

export type UserAffiliationFieldValueInput = {
  key: string;
  value: string;
};

export type AddUserAffiliationResult = {
  data: {
    addUserAffiliation: string | null;
  };
};

export const addUserAffiliationMutation = `
  mutation AddUserAffiliation($affiliationType: AffiliationType!, $fields: [UserAffiliationFieldValueInput!]) {
    addUserAffiliation(affiliationType: $affiliationType, fields: $fields)
  }
`;

export type UpdateUserAffiliationResult = {
  data: {
    updateUserAffiliation: boolean | null;
  };
};

export const updateUserAffiliationMutation = `
  mutation UpdateUserAffiliation($affiliationId: String!, $affiliationType: AffiliationType!, $fields: [UserAffiliationFieldValueInput!]) {
    updateUserAffiliation(affiliationId: $affiliationId, affiliationType: $affiliationType, fields: $fields)
  }
`;

export type UserAffiliationField = {
  key: string;
  value: string;
};

export type UserAffiliation = {
  affiliationId: string;
  affiliationType: string;
  fields: UserAffiliationField[];
};

export type GetUserAffiliationsResult = {
  data: {
    getUserAffiliations: UserAffiliation[] | null;
  };
};

export const getUserAffiliationsMutation = `
  mutation GetUserAffiliations {
    getUserAffiliations {
      affiliationId
      affiliationType
      fields {
        key
        value
      }
    }
  }
`;

export type RemoveUserAffiliationResult = {
  data: {
    removeUserAffiliation: boolean | null;
  };
};

export const removeUserAffiliationMutation = `
  mutation RemoveUserAffiliation($affiliationId: String!) {
    removeUserAffiliation(affiliationId: $affiliationId)
  }
`;
export type UpdateUserCprResult = {
  data: {
    updateUserProfile: {
      cprNumber: string | null;
    } | null;
  };
};

export const updateUserCprMutation = `
  mutation UpdateUserCpr($cprNumber: String!) {
    updateUserProfile(cprNumber: $cprNumber) {
      cprNumber
    }
  }
`;

export type GetUserProfileResult = {
  data: {
    getUserProfile: {
      cprNumber: string | null;
    } | null;
  };
};

export const getUserProfileMutation = `
  mutation GetUserProfile {
    getUserProfile {
      cprNumber
    }
  }
`;

export type UploadDocumentResult = {
  documentId: string;
};

export const uploadDocumentUrl = `/api/useraffiliations/documents`;
